interface ChartConfigColorEntryProps {
  label: string;
  color: string;
  defaultColor: string;
  onChange: (color: string) => void;
}

export default function ChartConfigColorEntry({
  label,
  color,
  defaultColor,
  onChange,
}: ChartConfigColorEntryProps) {
  return (
    <div className="flex items-center gap-3 rounded-lg border border-slate-100 bg-white px-3 py-2">
      <span className="min-w-0 flex-1 truncate text-[12px] font-medium text-slate-700">
        {label}
      </span>
      <input
        type="color"
        value={color || defaultColor}
        onChange={(e) => onChange(e.target.value)}
        className="h-7 w-9 cursor-pointer rounded border border-slate-200 bg-transparent p-0.5"
      />
      <input
        type="text"
        value={color}
        onChange={(e) => onChange(e.target.value)}
        placeholder="#000000"
        className="w-[80px] rounded-md border border-slate-200 bg-slate-50 px-2 py-1 text-[11px] font-mono text-slate-600 outline-none focus:border-indigo-400 focus:ring-1 focus:ring-indigo-400/20"
      />
    </div>
  );
}
